export enum HvacSchemaAspectRatio {
  FULL = 'full',
  MOST = 'most',
  HALF = 'half',
  LEAST = 'least',
}
